import { render, staticRenderFns } from "./UserMenuCombo.vue?vue&type=template&id=1ea02b06&scoped=true&"
import script from "./UserMenuCombo.vue?vue&type=script&lang=js&"
export * from "./UserMenuCombo.vue?vue&type=script&lang=js&"
import style0 from "./UserMenuCombo.vue?vue&type=style&index=0&id=1ea02b06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea02b06",
  null
  
)

export default component.exports